module.exports = __webpack_public_path__ + "static/media/S-6-Y.cf76eb0b.mp3";